import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Loader } from '@components/common';
import utils from '@utils';
import './balanceTransactionsTable.scss';

const BalanceTransactionsTable = ({
	rows = [], loading = false, timeZone, push,
}) => (
	<div className="position-relative margin-bottom-15">
		<div className="padding-horizontal-15">
			<Row className="border-solid border-1 border-color-default padding-vertical-10">
				<Col sm={2} className="text-right"><span>Date</span></Col>
				<Col sm={4}><span>Description</span></Col>
				<Col sm={2}><span>Type</span></Col>
				<Col sm={2} className="text-right"><span>Amount</span></Col>
				<Col sm={2} className="text-right"><span>Balance</span></Col>

			</Row>
			<For
				each="transaction"
				index="index"
				of={rows}
			>
				<Row
					key={`estimate_${index + 1}`}
					className={`bg-white border-solid border-1 border-color-default padding-vertical-10${!transaction.Paid ? ' text-danger' : ''}`}
				>
					<Col sm={2} className="date text-right">
						{utils.parseUTCDateToTimeZone(transaction.CreatedDateUTC, timeZone).format('MM/DD/YYYY')}
						<br />
						<div className="time">
							<i className="rkf rkf-clock text-gray" />
							{utils.parseUTCDateToTimeZone(transaction.CreatedDateUTC, timeZone).format('h:mm A')}
						</div>
					</Col>
					<Col sm={4}>
						<span>
							{ transaction.Amount >= 0 && transaction.JobEventName ? `Funds For: ${transaction.JobEventName}` : transaction.JobEventName || ''}
							<If condition={transaction.JobEventId}>
								<br />
								<button
									type="button"
									className="btn btn-link padding-0"
									onClick={() => push(`/jobs/${transaction.JobEventId}`)}
									aria-label={`Link to Job #${transaction.JobEventId}`}
								>
									Job #
									{transaction.JobEventId}
								</button>
							</If>
							<If condition={transaction.InvoiceId}>
								<br />
								<button
									type="button"
									className="btn btn-link padding-0"
									onClick={() => push(`/payments/${transaction.InvoiceId}`)}
									aria-label={`Link to Invoice #${transaction.InvoiceId}`}
								>
									Invoice #
									{transaction.InvoiceId}
								</button>
							</If>
						</span>
					</Col>
					<Col sm={2}>
						<span>
							{transaction.Paid ? transaction.ItemTypeDescription : 'Transaction Failed'}
						</span>
					</Col>
					<Col sm={2} className="text-right">
						<span className={`${transaction.Amount >= 0 && transaction.Paid
							? 'text-success'
							: 'text-danger'}${!transaction.Paid ? ' failed-payment' : ''}`}
						>
							{ transaction.Amount >= 0
								? `+ ${utils.currencyFormatter(transaction.Amount)}`
								: `- ${utils.currencyFormatter(Math.abs(transaction.Amount))}` }
						</span>
					</Col>
					<Col sm={2} className="text-right">
						<span>{ utils.currencyFormatter(transaction.Balance) }</span>
					</Col>
				</Row>
			</For>
		</div>
		<Loader active={loading} />
	</div>
);

BalanceTransactionsTable.propTypes = {
	rows     : PropTypes.array.isRequired,
	loading  : PropTypes.bool.isRequired,
	timeZone : PropTypes.string.isRequired,
	push     : PropTypes.func.isRequired,
};

export default BalanceTransactionsTable;
